var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrashCanFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M17.357-16.5H12.536l-.378-.584a1.02,1.02,0,0,0-.864-.416H6.7a1,1,0,0,0-.856.416l-.378.584H.643A.585.585,0,0,0,0-16v1a.585.585,0,0,0,.643.5H17.357A.585.585,0,0,0,18-15v-1A.585.585,0,0,0,17.357-16.5ZM2.138-2.906A1.793,1.793,0,0,0,4.062-1.5h9.876a1.793,1.793,0,0,0,1.925-1.406L16.714-13.5H1.286Z",
    transform: "translate(0 17.5)",
    fill: "#727c83"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashCanFilter);
export default __webpack_public_path__ + "static/media/icon_trash-can-filter.bb00b1f681b749c19d931e1ea2f23eed.svg";
export { ForwardRef as ReactComponent };